import { Property } from "../../types";
import FacilitiesSection from "./facilities-section";
import AmenitiesSection from "./amenities-section";

export default function PropertyInfo({
  property,
  trackTypeName,
}: {
  property: Property;
  trackTypeName?: string;
}) {
  return (
    <>
      <FacilitiesSection property={property} trackTypeName={trackTypeName} />
      <AmenitiesSection property={property} />
    </>
  );
}
